import React from 'react';
import { useTranslation } from 'react-i18next';
import useLazyRender from '../hooks/useLazyRender';
import ProductCard from './ProductCard';
import ProductCardSkeleton from './ProductCard/ProductCardSkeleton';

function LazyCategory({
  category,
  viewMode,
  visibleItems,
  hiddenCount,
  onExpandCategory,
  onAddToCart,
  onItemClick,
  getTranslatedText,
  isFavorite,
  onToggleFavorite,
  restaurantId,
  tableNumber,
  mode,
  showMoreLabel,
  onPromoExpired,
}) {
  const { t } = useTranslation();
  const [ref, isVisible] = useLazyRender('300px');

  // Check if category has timeRange and is outside active hours
  const timeRange = category.timeRange;
  const isOutsideTimeRange = (() => {
    if (!timeRange) return false;
    const now = new Date();
    const currentMinutes = now.getHours() * 60 + now.getMinutes();
    const [startH, startM] = timeRange.start.split(':').map(Number);
    const [endH, endM] = timeRange.end.split(':').map(Number);
    const startMinutes = startH * 60 + startM;
    const endMinutes = endH * 60 + endM;
    return currentMinutes < startMinutes || currentMinutes > endMinutes;
  })();

  return (
    <div ref={ref} className="category-section">
      <h2 className="category-name">{getTranslatedText(category, 'name')}</h2>
      {isOutsideTimeRange && timeRange && (
        <p className="category-time-hint">
          {t('menu.availableFromTo', { start: timeRange.start, end: timeRange.end })}
        </p>
      )}
      <div className={`items-grid items-grid--${viewMode}`}>
        {isVisible ? (
          visibleItems.map((item, itemIndex) => (
            <ProductCard
              key={item.itemId}
              item={item}
              viewMode={viewMode}
              onAddToCart={onAddToCart}
              onItemClick={onItemClick}
              getTranslatedText={getTranslatedText}
              isFavorite={isFavorite(item.itemId)}
              onToggleFavorite={onToggleFavorite}
              index={itemIndex}
              restaurantId={restaurantId}
              tableNumber={tableNumber}
              mode={mode}
              onPromoExpired={onPromoExpired}
            />
          ))
        ) : (
          <ProductCardSkeleton viewMode={viewMode} count={Math.min(visibleItems.length, 4)} />
        )}
      </div>
      {hiddenCount > 0 && (
        <button
          className="category-show-more"
          onClick={() => onExpandCategory(category.categoryId)}
        >
          {showMoreLabel}
        </button>
      )}
    </div>
  );
}

export default React.memo(LazyCategory);
